import React from 'react'
import InvestmentHero from './InvestmentPage/InvestmentHero'
import InvestmentSection from './InvestmentPage/InvestmentSection'
import InvestmentTrust from './InvestmentPage/InvestmentTrust'
import Footer from '../Footer/Footer'



function Investmentadvisory() {
    return (
        <div>
          <InvestmentHero/>
          <InvestmentSection/>
          <InvestmentTrust/>
          <Footer/>

        </div>
    )
}

export default Investmentadvisory
